import PasswordValidator from './components/PasswordValidator'

import {GlobalStyle} from './styledComponents'

const App = () => (
  <>
    <GlobalStyle />
    <PasswordValidator />
  </>
)

export default App
